import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

const Group = styled.div`
	width: 100%;
	display: inline-grid;
	grid-template-columns: repeat(${props => props.count}, minmax(0, 1fr));
	&& {
		> * {
			min-width: ${props => 100 / props.count}%;
			:not(:first-child) {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}
			:not(:last-child) {
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}
`;

const propTypes = {
	elementId: PropTypes.string,
	onClick: PropTypes.func,
	children: PropTypes.node,
	buttons: PropTypes.array,
	currentSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const ButtonGroup = ({
	elementId,
	onClick,
	children,
	buttons,
	currentSelected,
}) => {
	const count = (buttons && buttons.length) || React.Children.count(children);
	return (
		<Group count={count}>
			{children ||
				buttons.map(({ text, value }) => (
					<Button
						id={`${elementId}-button`}
						key={text}
						color={`${value === currentSelected ? 'primary' : 'default'}`}
						name={value}
						variant="contained"
						onClick={() => onClick(value)}
					>
						{text}
					</Button>
				))}
		</Group>
	);
};

ButtonGroup.propTypes = propTypes;

export default ButtonGroup;
